<template>
    <div class="mb-3" :class="bsClass">
        <label :for="name" class="form-label" v-if="!labelHidden">
            {{ label }}
            <span class="text-danger" v-if="required"> *</span>
        </label>
        <multiselect
            v-model="productSelected"
            :options="products"
            :close-on-select="true"
            :preserve-search="true"
            track-by="id"
            :placeholder="placeholder"
            label="name"
            :hide-selected="false"
            select-label=""
            selected-label=""
            deselect-label=""
            @search-change="searchProduct"
            :loading="loading"
            :internal-search="false"
        >
            <template v-slot:noResult>
                <span>Aucun résultats.</span>
            </template>
            <template v-slot:noOptions>
                <span>Écrivez pour rechercher un produit...</span>
            </template>
            <!-- Croix pour tout désélectionner -->
            <template #clear>
                <span class="multiselect__clear" role="button" v-if="productSelected && (productSelected.id ?? productSelected.code ?? productSelected.name ?? productSelected.label) != null" title="Effacer" aria-label="Effacer" @mousedown.prevent.stop="productSelected = null"></span>
            </template>
        </multiselect>
        <span class="invalid-feedback text-danger" v-html="errorMessage()"></span>
        <span class="form-text text-muted" v-if="informationContent !== null">
            {{ informationContent }}
        </span>
    </div>
</template>

<script>
import _ from 'lodash';
import axios from "axios";
export default {
    name: "FormSelectSearchProduct",
    props: {
        name : {
            type: String,
            required: true
        },
        label : {
            type: String,
            required: true
        },
        labelHidden : {
            type: Boolean,
            required: false,
            default: false
        },
        required : {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        informationContent : {
            type: String,
            required: false,
            default: null
        },
        reference : {
            type: String,
            required: false,
            default: 'multiple-select'
        },
        productPreSelected: {
            type: Object,
            required: false,
            default: null
        },
        errors: {
            required: true
        },
        bsClass: {
            type: String,
            required: false,
            default: "col-md-12"
        }
    },
    data() {
        return {
            productSelected : [],
            products: [],
            loading: false,
        }
    },
    methods: {
        searchProduct: _.debounce(function(query) {
            if (query.length < 3) {
                return;
            }
            this.loading = true;
            this.products = []
            axios.get('/api/search/products', { params: { query: query } })
                .then(response => {
                    response.data.data.forEach(product => {
                        this.products.push({
                            id: product.data.id,
                            name: product.data.product_code + ' - ' + product.data.name,
                            price_excluding_tax: product.data.price_excluding_tax
                        })
                    })
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }, 250),
        clearAll () {
            this.productSelected = []
        },
        clearErrors: function() {
            if (this.hasError) {
                this.errors[this.name] = null;
            }
        },
        errorClassObject: function() {
            return {
                "is-invalid": this.hasError
            }
        },
        errorMessage: function() {
            if (this.hasError) {
                return this.errors[this.name][0];
            }
        }
    },
    computed: {
        hasError() {
            return (
                this.errors &&
                this.errors[this.name] &&
                this.errors[this.name].length > 0
            );
        }
    },
    watch: {
        productSelected: function(){
            if( this.productSelected === null) {
                return this.$emit("update:field", null);
            } else {
                this.clearErrors(this.name);
                this.$emit("update:field", this.productSelected);
                this.$emit("update:price", this.productSelected);
            }
        },
        productPreSelected: {
            immediate: true,
            handler() {
                if (this.productPreSelected !== null && Object.keys(this.productPreSelected).length !== 0 ) {
                    this.productSelected = {
                        id: this.productPreSelected.data.id,
                        name: this.productPreSelected.data.name,
                        price_excluding_tax: this.productPreSelected.data.price_excluding_tax
                    }
                    this.products = [this.productSelected];
                    this.$emit("update:field", this.productSelected);
                }
            }
        }
    }
}
</script>

<style>

</style>
